<template>
  <div>
    <div class="vld-parent">
      <Loading :active.sync="isLoading"
      :is-full-page="fullPage"></loading>
    </div>

    <div class="page-header">
      <h3>Search</h3>
    </div>

    <div class="input-group mb-3">
      <input type="text" class="form-control" v-model="searchTerm" v-on:keyup.enter="runSearch" />
      <div class="input-group-append">
        <button class="btn btn-primary" type="button" @click="runSearch">Search</button>
      </div>
    </div>

    <ul class="mt-2 list-group">
      <li v-for="task in results" :key="task.id" class="list-group-item js-task-details-collapse-container">
        <QuickTask :task="task" />
      </li>
    </ul>
  </div>
</template>

<script>
import QuickTask from "components/QuickTask";
import NewQuickTask from "components/NewQuickTask";
import VueFuse from 'vue-fuse'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  components: {
    QuickTask,
    NewQuickTask,
    VueFuse,
    Loading
  },
  data () {
    return {
      isLoading: false,
      fullPage: true,
      searchTerm: null,
      results: [],
      todos: this.$store.state.tasks,
      keys: ['title', 'notes', 'files.filename']
    }
  },
  methods: {
    runSearch () {
      this.isLoading = true;
      return this.$search(this.searchTerm, this.$store.state.tasks, { keys: this.keys }).then(result => {
        this.results = result.slice(0, 30); // limit search results to first 30 items
        this.isLoading = false;
      })
    }
  }
};
</script>
